/**
 * @generated SignedSource<<5aed801758f451fdbfe1b7a0c48dfe94>>
 * @relayHash c16abd903a34a8c46fdda0c5e4584a85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f563dc70bd28214bd434424a4c75600970ccfa2f7ed00bb7b05deba1bc84d99a

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceShareableLinkAccessType = "EXTERNAL" | "INTERNAL_LICENSED" | "%future added value";
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_ORG_DEFAULT_POLICY" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "TRASHED" | "%future added value";
export type useShareableLinkPageDataProviderShareableLinkPageQuery$variables = {
  pageId: string;
};
export type useShareableLinkPageDataProviderShareableLinkPageQuery$data = {
  readonly publicLinkPage: {
    readonly accessType: ConfluenceShareableLinkAccessType | null | undefined;
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
    readonly publicLinkUrlPath: string | null | undefined;
  } | null | undefined;
};
export type useShareableLinkPageDataProviderShareableLinkPageQuery = {
  response: useShareableLinkPageDataProviderShareableLinkPageQuery$data;
  variables: useShareableLinkPageDataProviderShareableLinkPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      }
    ],
    "concreteType": "PublicLinkPage",
    "kind": "LinkedField",
    "name": "publicLinkPage",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "pageId"
      },
      {
        "kind": "ScalarField",
        "name": "pageStatus"
      },
      {
        "kind": "ScalarField",
        "name": "publicLinkUrlPath"
      },
      {
        "kind": "ScalarField",
        "name": "accessType"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useShareableLinkPageDataProviderShareableLinkPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useShareableLinkPageDataProviderShareableLinkPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c16abd903a34a8c46fdda0c5e4584a85",
    "id": "f563dc70bd28214bd434424a4c75600970ccfa2f7ed00bb7b05deba1bc84d99a",
    "metadata": {},
    "name": "useShareableLinkPageDataProviderShareableLinkPageQuery",
    "operationKind": "query",
    "text": "query useShareableLinkPageDataProviderShareableLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId,pageStatus,publicLinkUrlPath,accessType}}"
  }
};
})();

(node as any).hash = "44e2ea6cb045607236750000243c2492";

export default node;
